import PropTypes from "prop-types";
import React, { useState } from "react";
import axios from "axios";
import Popup from "reactjs-popup";
import { DebounceInput } from "react-debounce-input";
import DatePicker from "react-datepicker";
import { errorText, toastError } from "../../../../shared/toastHelper";
import { canSubmitHoldRemoval } from "./holdActionValidation";

const modalContentStyle = {
  textAlign: "left", border: "none", borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "500px", padding: "15px",
};

const REASONS = ["Skipping the market", "Playing another venue in market", "Tour cancelled", "Other"];

const HoldRemoveModal = ({ open, teamId, holdId, csrfToken, hasArtists, reasonRequired, onClose }) => {
  const [state, setState] = useState({});
  const [busy, setBusy] = useState(false);
  const update = (patch) => setState((prev) => ({ ...prev, ...patch }));

  const submit = (e) => {
    e.preventDefault();
    if (!canSubmitHoldRemoval(state, reasonRequired) || busy) return;
    setBusy(true);
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios
      .delete(`/teams/${teamId}/hold_groups/${holdId}`, {
        data: {
          hold_group_deletion: {
            reason: state.reason,
            explanation: state.explanation,
            follow_up_at: state.followUpAt,
          },
        },
      })
      .then(() => { window.location.replace("/dashboard"); })
      .catch((error) => { toastError(errorText(error, "Unable to delete hold. Please try again later.")); setBusy(false); });
  };

  return (
    <Popup open={open} contentStyle={modalContentStyle} closeOnDocumentClick onClose={onClose}>
      <div>
        <div className="text-center">
          <p className="strong mb-0" style={{ fontSize: "20px" }}>Are you sure?</p>
          <p className="text-muted mb-0">Confirm deletion of this hold.</p>
        </div>
        <form onSubmit={submit}>
          <div className="form-group mt-4">
            <select
              id="hold-remove-reason"
              className="form-control form-control-sm"
              style={{ borderColor: "#f5f5f5", borderRadius: "8px" }}
              value={state.reason || ""}
              onChange={(e) => update({ reason: e.target.value })}
            >
              {reasonRequired ? (
                <option value="" disabled>Reason for deletion</option>
              ) : (
                <option value="">Reason for deletion (optional)</option>
              )}
              {REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          {state.reason === "Other" && (
            <div className="form-group">
              <DebounceInput
                type="text"
                debounceTimeout={250}
                className="form-control form-control-sm"
                style={{ borderColor: "#f5f5f5", borderRadius: "8px" }}
                value={state.explanation || ""}
                onChange={(e) => update({ explanation: e.target.value })}
                id="hold-remove-explanation"
                placeholder="Please explain..."
              />
            </div>
          )}
          {hasArtists && (
            <div className="form-group">
              <div className="form-row">
                <div className="col-8">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      checked={state.followUp || false}
                      onChange={(e) => update({ followUp: e.target.checked })}
                      id="hold-remove-follow-up"
                    />
                    <label className="custom-control-label" htmlFor="hold-remove-follow-up">Schedule Follow-up</label>
                  </div>
                </div>
                <div className="col-4">
                  <DatePicker
                    selected={state.followUpAt || null}
                    className="form-control form-control-sm form-control-datepicker-sm"
                    placeholderText="Date"
                    disabled={!state.followUp}
                    onChange={(date) => update({ followUpAt: date })}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="mt-3 text-right">
            <a href="#" onClick={(e) => { e.preventDefault(); onClose(); }}>Cancel</a>
            <button
              type="submit"
              style={{ borderRadius: "8px" }}
              disabled={!canSubmitHoldRemoval(state, reasonRequired) || busy}
              className="btn btn-primary btn-sm ml-2"
            >
              Confirm
            </button>
          </div>
        </form>
      </div>
    </Popup>
  );
};

HoldRemoveModal.propTypes = {
  open: PropTypes.bool,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  holdId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  csrfToken: PropTypes.string,
  hasArtists: PropTypes.bool,
  reasonRequired: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default HoldRemoveModal;
